import { isEqual } from 'lodash'
import { createChildListPrintComponent } from 'factories/ChildListPrint'
import { t, toLocaleCurrency } from 'helpers/i18n'
import { allowPricing } from 'helpers/auth'

export default createChildListPrintComponent({
  entityName: 'processSetupSheet',
  childName: 'associatedProducts',
  extraTableSummary: (self) =>
    allowPricing() ? (
      <span
        style={{ marginRight: '5px' }}
      >{`${t('totalToolingCost:')} ${toLocaleCurrency(self.props.totalValue)}`}</span>
    ) : undefined,
  getRowClassName: (self) => (record) => {
    try {
      if (self.state.sortBy !== 'sequenceValue') {
        return undefined
      }

      const index = self.dataSource.findIndex((one) => isEqual(one, record))
      const [itemSeq] = self.dataSource[index].sequenceValue.split('.')
      const [nextSeq] = self.dataSource[index + 1].sequenceValue.split('.')

      return itemSeq !== nextSeq ? 'tofino-associated-products-sequence-separator' : undefined
    } catch (error) {
      return undefined
    }
  },
})()
